enum ErrorMessage {
  FB001 = 'access_denied',
  FB002 = 'missingScopes',
  FB003 = 'invalid_token',
  FB004 = 'notBusiness.0',
  FB005 = 'payload_username_idInstagram',
  FB006 = 'token_invalid',
  TT001 = 'access_denied',
  TT002 = 'failed_twitter_auth',
  TK001 = 'no_video',
  TK002 = 'error_received_token',
  TK003 = 'user_info_fetch_error',
  YT001 = 'no_channel_found_error',
  sameAccountProfileError = 'sameAccountProfileError',
  socialProfileHasAnotherAccountError = 'socialProfileHasAnotherAccountError',
  DuplicateProfileError = 'DuplicateProfileError',
  // NOVOS CÓDIGOS DE ERRO
  HC001 = 'DuplicateProfileError',
  HC002 = 'access_denied',
  HC003 = 'permission_denied',
  HC004 = 'noProfileLinked',

  // tiktok
  HC007 = 'no_video',
  HC018 = 'profile_link_creation_error',

  // youtube
  HC008 = 'no_channel_found_error',
  HC012 = 'no_channel_found_error',
}

export default ErrorMessage
